import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Icon, Popover, Typography } from '@zurich/ui/legacy/components';
import { useAppLinkStyled } from '@zurich/ui/legacy/hooks';
import { alpha, styled } from '@zurich/ui/legacy/utils';
export function ExternalMenu(_props) {
    const [anchorEl, setAnchorEl] = useState(null);
    const ExternalMenuItemAppLinkStyled = useAppLinkStyled(ExternalMenuItemLinkStyled);
    /* const handleExternalMenuClick = (
      event: React.MouseEvent<
        HTMLButtonElement | HTMLAnchorElement | HTMLSpanElement
      >
    ) => {
      setAnchorEl(event.currentTarget);
    };*/
    const handleExternalMenuClose = () => {
        setAnchorEl(null);
    };
    const externalMenuOptions = [
        {
            link: '',
            icon: _jsx(Icon, { color: "inherit", variant: "drive2", fontSize: "small" }),
            title: 'Motorrad',
            disabled: false,
        },
        {
            link: '',
            icon: _jsx(Icon, { color: "inherit", variant: "drive2" }),
            title: 'KFZ',
            disabled: true,
        },
        {
            link: '',
            icon: _jsx(Icon, { color: "inherit", variant: "home" }),
            title: 'Haushalt',
            disabled: false,
        },
        {
            link: '',
            icon: _jsx(Icon, { color: "inherit", variant: "heart" }),
            title: 'Leben',
            disabled: true,
        },
        {
            link: '',
            icon: _jsx(Icon, { color: "inherit", variant: "arm_use" }),
            title: 'Unfall',
            disabled: true,
        },
        {
            link: '',
            icon: _jsx(Icon, { color: "inherit", variant: "explosion" }),
            title: 'Schäden',
            disabled: true,
        },
        {
            link: '',
            icon: _jsx(Icon, { color: "inherit", variant: "form" }),
            title: 'Angebote',
            disabled: true,
        },
        {
            link: '',
            icon: _jsx(Icon, { color: "inherit", variant: "sustainability" }),
            title: 'Agrar',
            disabled: true,
        },
        {
            link: '',
            icon: _jsx(Icon, { color: "inherit", variant: "explosion" }),
            title: 'Glasbruch',
            disabled: true,
        },
    ];
    return (_jsx(_Fragment, { children: _jsx(Popover, { id: "external-menu", anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleExternalMenuClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center',
            }, children: _jsx(ExternalMenuContainerStyled, { children: externalMenuOptions.map(({ title, link, icon, disabled }, index) => (_jsxs(ExternalMenuItemAppLinkStyled, { href: link || '#', onClick: handleExternalMenuClose, target: "_blank", disabled: disabled, children: [_jsx("div", { children: icon }), _jsx(TypographyStyled, { disabled: disabled, children: title })] }, index))) }) }) }));
}
const ExternalMenuContainerStyled = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: theme.spacing(0.5),
    padding: theme.spacing(3),
}));
// disabled while Link/Button is disabled
// const ExternalMenuIconStyled = styled(Link)(({ theme }) => ({
//   marginRight: theme.spacing(2),
// }));
const ExternalMenuItemLinkStyled = styled('a')(({ theme, disabled }) => ({
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(2),
    textDecoration: 'none',
    color: !disabled
        ? theme.palette.primary.dark
        : theme.palette.secondary.light,
    '&:hover': {
        background: alpha(theme.palette.primary.light, 0.1),
        cursor: 'pointer',
    },
    pointerEvents: disabled ? 'none' : 'unset',
}));
const TypographyStyled = styled(Typography)(({ theme, disabled }) => ({
    marginTop: theme.spacing(1),
    color: !disabled
        ? theme.palette.primary.dark
        : theme.palette.secondary.light,
    pointerEvents: disabled ? 'none' : 'unset',
}));
